<template>
  <div>
    <a-result status="warning" :title="$t('message.noPermissionPage.title')">
      <template #extra>
<!--        <a-button  :size="$globalSize"  key="console" type="primary">-->
<!--          Go Console-->
<!--        </a-button>-->
      </template>
    </a-result>
  </div>
</template>

<script>
export default {};
</script>
